import React, { useState } from 'react';
interface CustomSliderProps {
  label: string;
  options: string[];
  defaultValue?: number;
  onChange?: (value: number) => void;
}
export function CustomSlider({
  label,
  options,
  defaultValue = 2,
  onChange
}: CustomSliderProps) {
  const [value, setValue] = useState(defaultValue);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value);
    setValue(newValue);
    onChange?.(newValue);
  };
  return <div className="space-y-3" data-id="element-1">
      <div className="flex items-center justify-between" data-id="element-2">
        <label className="text-sm font-medium text-zinc-300" data-id="element-3">{label}</label>
        <span className="text-sm text-yellow-400" data-id="element-4">{options[value]}</span>
      </div>

      <div className="relative" data-id="element-5">
        <input type="range" min="0" max={options.length - 1} value={value} onChange={handleChange} className="w-full h-2 bg-zinc-800 rounded-lg appearance-none cursor-pointer slider" style={{
        background: `linear-gradient(to right, #facc15 0%, #facc15 ${value / (options.length - 1) * 100}%, #27272a ${value / (options.length - 1) * 100}%, #27272a 100%)`
      }} data-id="element-6" />
        <style data-id="element-7">{`
          .slider::-webkit-slider-thumb {
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #facc15;
            cursor: pointer;
            border: 3px solid #09090b;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          }
          .slider::-moz-range-thumb {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #facc15;
            cursor: pointer;
            border: 3px solid #09090b;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          }
        `}</style>
      </div>

      <div className="flex justify-between text-xs text-zinc-600" data-id="element-8">
        <span data-id="element-9">{options[0]}</span>
        <span data-id="element-10">{options[options.length - 1]}</span>
      </div>
    </div>;
}